export enum BreakPoints {
	PHONE = '@media screen and (max-width: 767px)',
	PHONE_PORTRAIT = '@media screen and (orientation: portrait) and (max-width: 654px)',
	TABLET = '@media screen and (max-width: 1124px)',
	COMPUTER = '@media screen and (min-width: 1124px)',
}
